import { useEffect } from 'react';

// SEO Configuration for all pages
export const seoConfig = {
  siteName: "Tappezzeria Giovanni",
  siteUrl: "https://www.tappezzeriagiovanni.it",
  defaultDescription: "Pergole bioclimatiche, pergotende e tende da sole su misura a Pisa e in Toscana. Oltre 60 anni di artigianalità italiana per l'outdoor living di lusso.",
  phone: "050878189",
  mobile: "3517858967",
  email: "tappezzeria.giovanni@gmail.com",
  address: {
    street: "Via Pietro Metastasio 3/5",
    city: "Pisa",
    region: "Toscana",
    postalCode: "56017",
    country: "IT"
  },
  geo: {
    latitude: "43.7228",
    longitude: "10.4017"
  },
  socialProfiles: [
    "https://www.facebook.com/tappezzeriagiovanni",
    "https://www.instagram.com/tappezzeriagiovanni"
  ]
};

// Page-specific SEO data
export const pageSEO = {
  home: {
    title: "Pergole Bioclimatiche e Pergotende Pisa | Tappezzeria Giovanni",
    description: "Pergole bioclimatiche, pergotende e tende da sole su misura a Pisa e in Toscana. Oltre 60 anni di eccellenza artigianale per outdoor living di lusso. Richiedi preventivo gratuito.",
    keywords: "pergole bioclimatiche pisa, pergotende pisa, tende da sole pisa, outdoor living toscana, pergole toscana",
    h1: "Pergole Bioclimatiche e Outdoor Living a Pisa e in Toscana"
  },
  bioclimatiche: {
    title: "Pergole Bioclimatiche Pisa e Toscana | Installazione Professionale",
    description: "Pergole bioclimatiche con lamelle orientabili a Pisa e provincia. Strutture in alluminio certificate, domotica integrata. Ideali per il clima toscano. Preventivo gratuito.",
    keywords: "pergole bioclimatiche pisa, pergola bioclimatica toscana, lamelle orientabili, pergola alluminio pisa",
    h1: "Pergole Bioclimatiche a Pisa e in Toscana"
  },
  pergotende: {
    title: "Pergotende Pisa | Strutture Outdoor Premium | Tappezzeria Giovanni",
    description: "Pergotende su misura a Pisa e provincia. Strutture eleganti per terrazzi, giardini e locali. Protezione da sole e pioggia tutto l'anno. Preventivo gratuito.",
    keywords: "pergotende pisa, pergotenda toscana, coperture outdoor pisa, strutture terrazzi pisa",
    h1: "Pergotende Premium a Pisa e Provincia"
  },
  tendeDaSole: {
    title: "Tende da Sole Pisa | Su Misura | Tappezzeria Giovanni",
    description: "Tende da sole su misura a Pisa e in Toscana. Tende a bracci, a caduta, cappottine. Tessuti premium, motorizzazione smart. Oltre 60 anni di esperienza.",
    keywords: "tende da sole pisa, tende esterne pisa, tende motorizzate toscana, cappottine pisa",
    h1: "Tende da Sole su Misura a Pisa"
  },
  tendeInterno: {
    title: "Tende da Interno Pisa | Artigianali su Misura | Tappezzeria Giovanni",
    description: "Tende da interno artigianali a Pisa. Tende a pacchetto, pannello, classiche. Tessuti pregiati, lavorazione sartoriale. Consulenza d'arredo gratuita.",
    keywords: "tende interno pisa, tende artigianali toscana, tende su misura pisa, tessuti pregiati",
    h1: "Tende da Interno Artigianali a Pisa"
  },
  vetrate: {
    title: "Vetrate Panoramiche Pisa | Chiusure Vetrate | Tappezzeria Giovanni",
    description: "Vetrate panoramiche scorrevoli a Pisa e Toscana. Chiusure per pergole e verande. Vetri temperati, isolamento termico. Installazione professionale.",
    keywords: "vetrate panoramiche pisa, chiusure vetrate toscana, vetrate scorrevoli pisa, vetrate pergole",
    h1: "Vetrate Panoramiche a Pisa e Provincia"
  },
  about: {
    title: "Chi Siamo | Tappezzeria Giovanni Pisa | Dal 1967",
    description: "Tappezzeria Giovanni: oltre 60 anni di artigianalità italiana a Pisa. Specialisti in pergole bioclimatiche, pergotende e outdoor living di lusso in Toscana.",
    keywords: "tappezzeria giovanni pisa, artigiani tende pisa, azienda outdoor pisa, storia tappezzeria",
    h1: "Oltre 60 Anni di Artigianalità a Pisa"
  },
  preventivo: {
    title: "Richiedi Preventivo Gratuito | Pergole e Tende Pisa",
    description: "Richiedi un preventivo gratuito per pergole bioclimatiche, pergotende o tende da sole a Pisa e provincia. Sopralluogo e consulenza senza impegno.",
    keywords: "preventivo pergole pisa, preventivo tende pisa, consulenza outdoor pisa",
    h1: "Richiedi un Preventivo Personalizzato"
  },
  areeServite: {
    title: "Aree Servite | Pergole e Tende in Toscana | Tappezzeria Giovanni",
    description: "Installiamo pergole bioclimatiche, pergotende e tende in tutta la Toscana: Pisa, Lucca, Livorno, Firenze, Massa-Carrara, Pistoia. Scopri le zone servite.",
    keywords: "pergole toscana, tende lucca, pergotende livorno, outdoor firenze",
    h1: "Le Nostre Aree di Intervento in Toscana"
  }
};

// Location-specific SEO data
export const locationSEO = {
  pisa: {
    title: "Pergole Bioclimatiche e Pergotende Pisa | Tappezzeria Giovanni",
    description: "Installazione pergole bioclimatiche e pergotende a Pisa città. Soluzioni outdoor di lusso per ville, terrazzi e attività commerciali. Preventivo gratuito.",
    keywords: "pergole pisa città, pergotende pisa, bioclimatiche pisa, outdoor living pisa",
    h1: "Pergole Bioclimatiche e Pergotende a Pisa",
    content: {
      intro: "Pisa, con il suo clima mediterraneo mite e le numerose giornate di sole, è la location ideale per soluzioni outdoor di alto livello. Le nostre pergole bioclimatiche e pergotende permettono di vivere terrazzi e giardini tutto l'anno, valorizzando ville storiche, residenze moderne e locali del centro.",
      climate: "Il clima pisano, caratterizzato da estati calde e inverni miti, rende le pergole bioclimatiche la scelta perfetta per chi desidera uno spazio esterno vivibile in ogni stagione. Le lamelle orientabili permettono di gestire la luce e la ventilazione naturale, riducendo i costi di climatizzazione.",
      areas: ["Centro Storico", "Marina di Pisa", "Tirrenia", "Calambrone", "San Piero a Grado", "Cisanello", "I Passi"]
    }
  },
  provinciaPisa: {
    title: "Pergole e Pergotende Provincia di Pisa | Tappezzeria Giovanni",
    description: "Pergole bioclimatiche e pergotende in tutta la provincia di Pisa: Cascina, Pontedera, San Giuliano Terme, Volterra. Installazione professionale, preventivo gratuito.",
    keywords: "pergole provincia pisa, pergotende cascina, bioclimatiche pontedera, outdoor san giuliano terme",
    h1: "Pergole e Pergotende nella Provincia di Pisa",
    content: {
      intro: "Serviamo l'intera provincia di Pisa con installazioni di pergole bioclimatiche, pergotende e soluzioni outdoor di prestigio. Dalle colline di Volterra alla pianura di Cascina, ogni progetto è studiato per integrarsi con l'architettura locale.",
      towns: ["Cascina", "Pontedera", "San Giuliano Terme", "Volterra", "San Miniato", "Calci", "Vecchiano", "Vicopisano", "Buti", "Capannoli", "Ponsacco"]
    }
  },
  lucca: {
    title: "Pergole Bioclimatiche Lucca | Installazione | Tappezzeria Giovanni",
    description: "Pergole bioclimatiche e pergotende a Lucca e provincia. Soluzioni eleganti per ville, agriturismi e strutture ricettive. Sopralluogo gratuito.",
    keywords: "pergole lucca, pergotende lucca, bioclimatiche lucca, outdoor living lucca",
    h1: "Pergole Bioclimatiche a Lucca e Provincia",
    content: {
      intro: "Lucca, città d'arte e cultura, richiede soluzioni outdoor che rispettino l'eleganza architettonica del territorio. Le nostre pergole bioclimatiche si integrano perfettamente con ville storiche, agriturismi e residenze di pregio nella Piana di Lucca e in Garfagnana.",
      areas: ["Lucca Centro", "Viareggio", "Forte dei Marmi", "Pietrasanta", "Camaiore", "Capannori", "Altopascio", "Barga", "Castelnuovo Garfagnana"]
    }
  },
  livorno: {
    title: "Pergole e Pergotende Livorno | Sul Mare | Tappezzeria Giovanni",
    description: "Pergole bioclimatiche e pergotende a Livorno e Costa degli Etruschi. Strutture resistenti alla salsedine per ville sul mare e stabilimenti. Preventivo gratuito.",
    keywords: "pergole livorno, pergotende costa etruschi, bioclimatiche mare, outdoor livorno",
    h1: "Pergole Bioclimatiche a Livorno e Costa degli Etruschi",
    content: {
      intro: "A Livorno e lungo la Costa degli Etruschi installiamo pergole bioclimatiche e pergotende progettate per resistere all'ambiente marino. Strutture in alluminio trattato anti-salsedine, ideali per ville fronte mare, stabilimenti balneari e ristoranti sulla costa.",
      areas: ["Livorno Centro", "Ardenza", "Antignano", "Quercianella", "Castiglioncello", "Rosignano", "Cecina", "San Vincenzo", "Piombino"]
    }
  },
  firenze: {
    title: "Pergole Bioclimatiche Firenze | Lusso | Tappezzeria Giovanni",
    description: "Pergole bioclimatiche di lusso a Firenze e provincia. Soluzioni premium per attici, terrazze panoramiche e ville nel Chianti. Consulenza specializzata.",
    keywords: "pergole firenze, pergotende firenze, bioclimatiche chianti, outdoor lusso firenze",
    h1: "Pergole Bioclimatiche di Lusso a Firenze",
    content: {
      intro: "Firenze e le colline del Chianti rappresentano l'eccellenza dell'abitare italiano. Le nostre pergole bioclimatiche sono pensate per atticchiaici con vista sui monumenti, ville medicee, agriturismi di charme e strutture ricettive di alto livello.",
      areas: ["Firenze Centro", "Fiesole", "Bagno a Ripoli", "Impruneta", "Greve in Chianti", "San Casciano", "Scandicci", "Sesto Fiorentino"]
    }
  },
  massaCarrara: {
    title: "Pergole Bioclimatiche Massa Carrara | Tappezzeria Giovanni",
    description: "Pergole bioclimatiche e pergotende a Massa, Carrara e Lunigiana. Strutture outdoor per ville, hotel e ristoranti. Installazione professionale.",
    keywords: "pergole massa, pergotende carrara, bioclimatiche lunigiana, outdoor versilia",
    h1: "Pergole e Pergotende a Massa-Carrara",
    content: {
      intro: "Dalla costa della Versilia alle colline della Lunigiana, installiamo pergole bioclimatiche e pergotende su misura. Soluzioni perfette per il clima variegato della provincia, dalle brezze marine ai freschi dell'entroterra.",
      areas: ["Massa", "Carrara", "Marina di Massa", "Marina di Carrara", "Montignoso", "Aulla", "Pontremoli", "Fivizzano"]
    }
  },
  pistoia: {
    title: "Pergole Bioclimatiche Pistoia | Tappezzeria Giovanni",
    description: "Pergole bioclimatiche e pergotende a Pistoia e Valdinievole. Soluzioni outdoor per ville, vivai e strutture termali. Preventivo gratuito.",
    keywords: "pergole pistoia, pergotende montecatini, bioclimatiche valdinievole, outdoor pistoia",
    h1: "Pergole Bioclimatiche a Pistoia e Valdinievole",
    content: {
      intro: "Pistoia, città del verde e dei vivai, e la Valdinievole con le sue terme storiche, richiedono soluzioni outdoor che valorizzino il rapporto con la natura. Le nostre pergole bioclimatiche creano spazi perfetti per vivere il giardino tutto l'anno.",
      areas: ["Pistoia Centro", "Montecatini Terme", "Monsummano Terme", "Pescia", "Quarrata", "Agliana", "Serravalle Pistoiese"]
    }
  }
};

// Schema.org structured data
export const generateLocalBusinessSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": seoConfig.siteUrl,
    "name": seoConfig.siteName,
    "image": `${seoConfig.siteUrl}/images/logo.png`,
    "description": seoConfig.defaultDescription,
    "url": seoConfig.siteUrl,
    "telephone": `+39${seoConfig.phone}`,
    "email": seoConfig.email,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": seoConfig.address.street,
      "addressLocality": seoConfig.address.city,
      "addressRegion": seoConfig.address.region,
      "postalCode": seoConfig.address.postalCode,
      "addressCountry": seoConfig.address.country
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": seoConfig.geo.latitude,
      "longitude": seoConfig.geo.longitude
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "13:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "15:00",
        "closes": "19:00"
      }
    ],
    "priceRange": "€€€",
    "areaServed": [
      { "@type": "City", "name": "Pisa" },
      { "@type": "State", "name": "Toscana" },
      { "@type": "City", "name": "Lucca" },
      { "@type": "City", "name": "Livorno" },
      { "@type": "City", "name": "Firenze" },
      { "@type": "City", "name": "Pistoia" },
      { "@type": "City", "name": "Massa" }
    ],
    "sameAs": seoConfig.socialProfiles,
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Servizi Outdoor Living",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Pergole Bioclimatiche",
            "description": "Installazione pergole bioclimatiche con lamelle orientabili"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Pergotende",
            "description": "Pergotende su misura per esterni"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Tende da Sole",
            "description": "Tende da sole motorizzate e manuali"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Vetrate Panoramiche",
            "description": "Chiusure vetrate per pergole e verande"
          }
        }
      ]
    }
  };
};

export const generateServiceSchema = (service) => {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": service.name,
    "provider": {
      "@type": "LocalBusiness",
      "name": seoConfig.siteName,
      "address": {
        "@type": "PostalAddress",
        "addressLocality": seoConfig.address.city,
        "addressRegion": seoConfig.address.region
      }
    },
    "areaServed": {
      "@type": "State",
      "name": "Toscana"
    },
    "description": service.description
  };
};

export const generateBreadcrumbSchema = (items) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": `${seoConfig.siteUrl}${item.path}`
    }))
  };
};

// Hook for setting page SEO
export const usePageSEO = (pageKey) => {
  useEffect(() => {
    const seo = pageSEO[pageKey];
    if (seo) {
      document.title = seo.title;
      
      // Update meta description
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        document.head.appendChild(metaDescription);
      }
      metaDescription.content = seo.description;

      // Update meta keywords
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.name = 'keywords';
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.content = seo.keywords;
    }
  }, [pageKey]);
};

export default seoConfig;
